<template>
    <div style="padding: 2rem 3rem; text-align: left;">
        <div class="field">
            <b-form-group label="Re-Name Your Device (Optional):" label-for="create-installation-device-name">
                <b-form-input id="create-installation-device-name" v-model="model.device.name" type="text" required />
            </b-form-group>

          <!-- <b-form-group label="Valve Control Enabled:"
                label-for="create-installation-installation_valve_control_enabled">
                <b-form-select v-model="model.installation.valve_control_enabled" :options="valve_control_options"
                    id="create-installation-installation-valve_control_enabled" />
            </b-form-group>
       -->
       </div>
    </div>
</template>

<script>

    const default_location_type = [
        { text: 'Outdoors below ground level', value: 'Outdoors_below_ground_level' },
        { text: 'Indoors below ground level', value: 'Indoors_below_ground_level' },
        { text: 'Outdoors ground level', value: 'Outdoors_ground_level' },
        { text: 'Indoors ground level', value: 'Indoors_ground_level' },
        { text: 'Other', value: 'Other' }
    ]

    const default_service_type = [
        { text: 'Residential', value: 'Residential' },
        { text: 'Commercial', value: 'Commercial' },
        { text: 'Multi Residential', value: 'Multi_Residential' },
        { text: 'Multi Comercial', value: 'Multi_Comercial' } 
    ]

    const default_meter_size = [
        { text: '5/8" Standard Meter', value: 'five_eights' },
        { text: '1" Standard Meter', value: 'one_inch' },
        { text: '1.5" Standard Meter', value: 'one_and_half_inches' },
        { text: '2" Standard Meter', value: 'two_inches' },
        { text: 'Large Commercial', value: 'large_comercial' },
        { text: 'Other', value: 'Other' }
    ]

    const default_meter_type = [
        { text: 'Positive Displacement', value: 'Positive_Diplacement' },
        { text: 'Large Commercial', value: 'Large_Commercial' },
        { text: 'Compound Low Res stg1', value: 'Compound_Low_Res_stg1' },
        { text: 'Compound High Res stg2', value: 'Compound_High_Res_stg2' },
        { text: 'Other', value: 'Other' } 
    ]

    const default_make = [
        { text: 'Neptune', value: 'Neptune' },
        { text: 'Badger', value: 'Badger' },
        { text: 'Master Meter', value: 'Master_Meter' },
        { text: 'Sensus', value: 'Sensus' },
        { text: 'Hach', value: 'Hach' },
        { text: 'Other', value: 'Other' }
    ]

    const boolean_options = [
        { value:true, text:'Yes' }, 
        { value:false, text:'No' }
    ]

    export default {
        props: {
            model:{ type: Object }
        },

        data(){
            return {
                valve_control_options: boolean_options,
                location_type: default_location_type,
                service_type: default_service_type,
                meter_size: default_meter_size,
                meter_type: default_meter_type,
                make: default_make
            }
        },

        created(){ 
            
            const {
                location_type = [], 
                service_type = [],
                meter_size = [], 
                meter_type = [], 
                make = []
            } = this.model

            this.model.device.name = 'MeterDog MDS-001'
            this.location_type = location_type.length ? location_type : this.location_type
            this.service_type = service_type.length ? service_type : this.service_type
            this.meter_size = meter_size.length ? meter_size : this.meter_size
            this.meter_type = meter_type.length ? meter_type : this.meter_type
            this.make = make.length ? make : this.make
        },

        mounted() {
            this.$emit('can-continue', {value: true})
        },

        methods:{},
    }

</script>

<style />
